<template>
  <div class="spsidebar">
    <!-- {{Providers}} -->
    <div class="list">
      <ul v-if="selectio">
        <li
          :class="this.selectio ? 'active' : 'nonactive'"
          @click="$emit('listclickedpoint', $event, selectioData)"
        >
          <img
            class="badgesp-logo"
            v-if="activePointProviderLogo"
            :src="activePointProviderLogo"
            alt=""
          />
          <div class="infosp">
            <span class="badgesp">{{ badge }}</span> {{ selectio }}
          </div>
        </li>
      </ul>
      <perfect-scrollbar>
        <div class="scroll-me">
          <ul>
            <li
              v-for="(point, x) in PointList"
              :key="x"
              :data-point="point.id"
              :class="point.id === PicekdPoint[0] ? 'hide' : ''"
              @click="$emit('listclickedpoint', $event, point)"
            >
              <div v-for="(image, k) in Providers" :key="k">
                <img
                  class="badgesp-logo"
                  v-if="point.provider == image.name"
                  :src="point.provider == image.name ? image.image : ''"
                  alt=""
                />
              </div>
              <div class="infosp">
                <span v-html="point.code" class="badgesp badgesp-white"></span>
                <h4 v-html="point.title"></h4>
              </div>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    PicekdPoint: function () {
      this.selectedPoint(this.PointList);
    },
  },
  name: "SiedbarComponent",
  props: {
    PointList: Array,
    PicekdPoint: Array,
    Providers: Array,
  },
  methods: {
    // geoloc(val) {
    //   val = ''
    //   console.log(val);
    // },
    getPointLogo(point, providers) {
      // console.log(point);
      // console.log(providers);

      providers.forEach(function (prov) {
        // console.log("prov = " + JSON.stringify(prov));
        if (point == prov.name) {
          // console.log('KABOWONGA!')
          return "sads";
          // return '<img src="'+prov.image+'" />';
        } else {
          return "asdsd";
        }
      });
    },
    selectedPoint(PointList) {
      Object.values(PointList).forEach((val) => {
        if (val.id == this.PicekdPoint[0]) {
          // return val.id
          this.selectioData = val;
          this.selectio = val.title;
          this.badge = val.code;
          // console.log(val);
          Object.values(this.Providers).forEach((val2) => {
            if (val.provider == val2.name) {
              this.activePointProviderLogo = val2.image;
            }
          });
        } else {
          // this.selectio = 'Bzzz';
        }
      });
    },
  },
  computed: {
    innerHtml() {
      return "<div>hehe</div>";
    },
  },
  data() {
    return {
      activePointProviderLogo: "",
      selectio: "",
      selectioData: [],
      badge: "",
      ProvidersList: this.Providers,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* container */

.ps {
  max-height: 350px;
  height: 100%;
}
.spsidebar ul {
  margin: 0;
  padding: 0;
}
.spsidebar li {
  border-radius: 2px;
  width: 100%;
  padding: 8px 10px;
  display: flex;
  font-size: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-weight: 600;
}
.spsidebar li.active {
  background-color: green;
  color: white;
}
.nice-bar-slider-x {
  display: none !important;
}
.spsidebar h4 {
  font-size: 14px;
  text-align: left;
  text-align: left;
  padding: 0;
  margin: 0;
}
.spsidebar li:hover {
  background: black;
  color: white;
  cursor: pointer;
}
a {
  color: #42b983;
}
.spsidebar li.hide {
  display: none;
}
.badgesp-logo {
  width: 40px;
  height: 40px;
  border-radius: 2px;
  margin-right: 10px;
}
.badgesp {
  border: 1px solid white;
  padding: 1px 8px;
  margin-right: 10px;
  border-radius: 2px;
  display: block;
  align-self: flex-start;
  font-size: 10px;
  margin-bottom: 3px;
}

.badgesp-white {
  border: 1px solid black;
}

.scroll-me ul li:hover .badgesp-white {
  border: 1px solid white !important;
}

.infosp {
  display: flex;
  flex-direction: column;
}
</style>
